
































import {Component, Vue} from 'vue-property-decorator'
import HeaderBar from '@/components/HeaderBar.vue'
import MenusStore from "@/store/modules/MenusStore";
import MenuTopNavi from "@/pages/MenuTopPage/MenuTopNavi.vue";
import StoresSelector from "@/pages/MenuTopPage/StoresSelector.vue";
import ScheduleOptionSelector from "@/components/OptionSelector/ScheduleOptionSelector.vue";
import ListSorter from "@/components/ListSorter/ListSorter.vue";
import ScheduleList from "@/pages/MenuTopPage/ScheduleList.vue";
import SchedulesStore from "@/store/modules/SchedulesStore";
import CategoriesStore from "@/_common/api/store/modules/CategoriesStore";
import Background from '@/components/Background.vue'
import Navigator from '@/components/Navigator.vue';

@Component({
    components: {
        ListSorter,
        ScheduleOptionSelector,
        StoresSelector,
        MenuTopNavi,
        HeaderBar,
        ScheduleList,
        Background,
        Navigator,
    },
})
export default class MenuTopPage extends Vue {

    async created() {
        CategoriesStore.init(this.menuId);
        MenusStore.init();
        SchedulesStore.init(this.menuId);
    }

    get menuId(): number {
        return Number(this.$route.params.menuId);
    }

    get menu(): CMS.Menu {
        return MenusStore.menuById[this.menuId] || {};
    }

    private onClickCancel() {
        this.$router.push({name: 'menu_list'});
    }

}
